module.exports = __webpack_public_path__ + "img/logo.2c1bfbb0.png";